import { render, staticRenderFns } from "./FileBreadcrumb.vue?vue&type=template&id=c5380730&scoped=true&"
import script from "./FileBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./FileBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./FileBreadcrumb.vue?vue&type=style&index=0&id=c5380730&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5380730",
  null
  
)

export default component.exports